export const educationData = [{
    "title": "National University of Singapore",
    "content": `Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quis sapiente 
    laborum cupiditate possimus labore, hic temporibus velit dicta earum
    suscipit commodi eum enim atque at? Et perspiciatis dolore iure
    voluptatem.`,
    "link": ""
}, {
    "title": "Nanyang Junior College",
    "content": `Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quis sapiente 
    laborum cupiditate possimus labore, hic temporibus velit dicta earum
    suscipit commodi eum enim atque at? Et perspiciatis dolore iure
    voluptatem.`,
    "link": ""
}, {
    "title": "Maris Stella High School",
    "content": `Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quis sapiente 
    laborum cupiditate possimus labore, hic temporibus velit dicta earum
    suscipit commodi eum enim atque at? Et perspiciatis dolore iure
    voluptatem.`,
    "link": "Hello World"
}]